import { CommonModule } from "@angular/common";
import { Component, Input } from "@angular/core";
import { ReactiveFormsModule } from "@angular/forms";
import { TranslateModule } from "@ngx-translate/core";
import { Member } from "@shared/models/member";
import { DropdownModule } from "primeng/dropdown";

@Component({
  selector: "app-user-address",
  standalone: true,
  imports: [CommonModule, DropdownModule, ReactiveFormsModule, TranslateModule],
  templateUrl: "./user-address.component.html",
  styleUrl: "./user-address.component.scss",
})
export class UserAddressComponent {
  @Input({ required: true }) isEditMode = false;
  @Input({ required: true }) member!: Member | undefined;
  @Input({ required: true }) isFirstContract = false;
}
